import axios from 'src/admin-axios';
import Constants from 'src/constants';

export const settings = {
    namespaced: true,
    state: {
        settingsFault: [],
    },
    getters: {
        getSettingsFault (state) {
            return state.settingsFault;
        },
    },
    mutations: {
        setSettingsFault (state, data) {
            state.settingsFault = data;
        },
    },
    actions: {
        async fetchSettingsFault ({ dispatch, commit }) {
            const url = '/setting-faults';
            try {
                const details = await axios.get(url);
                commit('setSettingsFault', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting Settings Fault.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async  updateSettingsFaultStatus ({ dispatch }, payload) {
            const url = `/setting-faults/${payload.id}`;
            try {
                await axios.put(url, { status: payload.status });
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in updating the settings fault status.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
    },
};
